// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tryitouteditor {
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.tryitouteditor ngx-monaco-editor {
  width: 100%;
  height: 58vh;
  position: relative;
  right: 16px;
}

.example-tree-invisible {
  display: none;
}

.example-tree ul,
.example-tree li {
  margin-top: 0;
  margin-bottom: 0;
  list-style-type: none;
}

.textColor {
  color: green;
}

.mat-tree-node {
  min-height: 1px;
  align-items: flex-start;
}

.mat-icon-button {
  height: 1px;
  width: 20px;
}

.mat-icon-rtl-mirror {
  vertical-align: top;
}

.accession_field {
  height: 28px !important;
  margin-left: 3%;
  padding-left: 2%;
  font-size: 12px !important;
}

.accession_field::placeholder {
  font-size: 12px !important;
}

.gqr-accession-col {
  width: 190px;
  max-width: 190px;
  flex: 0 0 190px;
}

.gqr-entity-col {
  flex: 1 1 auto;
  min-width: 0;
}

.gqr-get-xml-btn-wrap {
  display: flex;
  align-items: center;
  align-self: center;
}

.gqr-get-xml-btn {
  height: 32px;
  min-width: 36px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

::ng-deep .gqr-input-row .gqr-filter-input .autocomplete-container {
  height: auto;
  width: 100%;
}

::ng-deep .gqr-input-row .gqr-filter-input form {
  width: 100%;
}

::ng-deep .gqr-input-row .ng-autocompleteaccount .autocomplete-container .input-container input {
  height: 32px;
  min-height: 32px;
  font-size: 12px;
}

.field_droping {
  width: 100%;
  margin-left: 4%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  top: -3px;
  background-color: rgb(255, 255, 255);
  left: -5px;
  height: 32px;
}

::ng-deep .field_droping .mat-form-field-wrapper {
  padding-bottom: 0 !important;
}

::ng-deep .field_droping .mat-form-field-flex {
  padding: 0 !important;
}

.mod_header {
  padding-inline: 1%;
  background-color: #17a0b4 !important;
  padding-block: 5px;
  font-size: 12px !important;
  color: white;
}

.Template_dropDown {
  height: 32px;
  border-radius: 5px;
  padding-inline: 1%;
  position: relative;
  top: 1%;
  background-color: white;
  margin-left: 1px;
  margin-right: 2%;
  margin-block: 1%;
}

::ng-deep.Template_dropDown .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.Template_dropDown .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.Template_dropDown .mat-form-field-label-wrapper {
  top: -1px !important;
}

::ng-deep.Template_dropDown .mat-select-trigger {
  min-width: 10vw;
}

.mat_selection {
  margin-left: 4%;
  margin-bottom: 4%;
  height: 35px;
  border-radius: 5px;
  padding-inline: 1%;
  padding-bottom: 1%;
}

::ng-deep.mat_selection .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.mat_selection .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.mat-selection_label .mat-form-field-label-wrapper {
  position: absolute !important;
  top: 1px !important;
}

::ng-deep.mat-selection_label .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.selection_label .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.selection_label .mat-select-trigger {
  min-width: 10vw;
}

::ng-deep.path_class {
  width: 100%;
}

::ng-deep.pushmodal .modal-dialog {
  max-width: 50% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.pushmodal {
  top: 4% !important;
}

.ellipsisfull {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* width: 100% !important; */
  max-width: 90%;
}

::ng-deep .field_droping .mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  margin-left: 8px !important;
}

::ng-deep .field_droping .mat-form-field-appearance-outline .mat-form-field-infix {
  padding: 3px 7px !important;
}

::ng-deep.Version_dropDowns .mat-form-field-wrapper .mat-form-field-flex .mat-form-field-infix .mat-select .mat-select-trigger .mat-select-value {
  width: 65% !important;
}

.Version_dropDowns {
  height: 32px;
  border-radius: 5px;
  position: relative;
  top: -7px;
  background-color: white;
  margin-block: 1%;
  padding-left: 5px;
  width: 60%;
}

::ng-deep.Version_dropDowns .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.Version_dropDowns .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.Version_dropDowns .mat-form-field-label-wrapper {
  top: -1px !important;
}

::ng-deep.Version_dropDowns .mat-select-trigger {
  min-width: 13vw !important;
}

::ng-deep.Version_dropDowns .mat-select-arrow {
  position: relative !important;
  right: 47% !important;
}

::ng-deep.myCustomModalViewfilehl7Viewer .modal-dialog {
  max-width: 80% !important;
  max-height: 60% !important;
  height: 60% !important;
  padding: 0 !important;
  display: flex !important;
  justify-content: center !important;
}

::ng-deep.matoutlinestyles.versionfield {
  width: 70% !important;
}
::ng-deep.matoutlinestyles.versionfield .mat-mdc-text-field-wrapper {
  padding-block: 0px !important;
}

::ng-deep .rule-engine-tabs.mat-mdc-tab-group.mat-mdc-tab-group-stretch-tabs > .mat-mdc-tab-header .mat-mdc-tab {
  flex-grow: 0;
}

::ng-deep .rule-engine-tabs .mat-mdc-tab {
  background-color: white;
}

::ng-deep .rule-engine-tabs .mat-mdc-tab.mat-mdc-tab-active {
  background-color: white;
}

::ng-deep .rule-engine-tabs .mat-mdc-tab-label-container {
  background-color: white !important;
}

.qualified-routes-list {
  margin-top: 20px;
}

.qualified-routes-list ul {
  list-style-type: none;
  padding: 0;
}

.qualified-routes-list .route-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 5px;
}

.qualified-routes-list .route-item:hover {
  background-color: #e3eaec;
}

.qualified-routes-list .copy-icon-btn {
  border: none;
  background: transparent;
  padding: 0;
  line-height: 1;
  cursor: pointer;
  color: inherit;
}

.scrollable-output {
  overflow-y: auto;
  height: 52vh;
  width: 90vh;
  padding-right: 10px;
  font-size: 12px;
  margin-top: 25px;
}

.scrollable-routes {
  overflow-y: auto;
  padding: 10px;
}

.Ruleengineasterisk {
  font-size: 7px;
  position: absolute;
  color: rgba(244, 68, 85, 0.768627451) !important;
}

.search-builder-tab {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.search-builder-tab .search-builder-filter-card {
  background-color: rgba(211, 211, 211, 0.2509803922);
  border: none;
  margin-bottom: 8px;
  flex: 0 0 auto;
  z-index: 5;
}
.search-builder-tab .modal-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  padding-top: 0 !important;
}
.search-builder-tab .search-builder-filter-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 12px;
  width: 100%;
}
.search-builder-tab .sb-filter-field {
  display: flex;
  flex: 1 1 0;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.search-builder-tab .sb-filter-field-lab {
  flex: 1.15 1 0;
}
.search-builder-tab .sb-filter-label {
  flex: 0 0 auto;
  white-space: nowrap;
  margin: 0;
  font-size: 12px;
  padding-left: 4px;
}
.search-builder-tab .sb-filter-input {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
}
.search-builder-tab .sb-filter-actions {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 6px;
  padding-right: 4px;
  white-space: nowrap;
}
.search-builder-tab .sb-passive-checkbox {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  margin-right: 4px;
}
.search-builder-tab .sb-passive-checkbox input {
  margin: 0;
  cursor: pointer;
}
.search-builder-tab .search-builder-advanced-card {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 8px 10px;
  background: #fff;
  max-height: 34vh;
  overflow-x: hidden;
  overflow-y: auto;
}
.search-builder-tab .search-builder-advanced-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 8px;
}
.search-builder-tab .search-builder-advanced-rule-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}
.search-builder-tab .sb-adv-field {
  width: 220px;
  min-width: 160px;
  font-size: 12px;
  height: 32px;
}
.search-builder-tab .sb-adv-select-op {
  width: 110px;
  font-size: 12px;
  height: 32px;
}
.search-builder-tab .sb-adv-value {
  min-width: 160px;
  flex: 1 1 140px;
  font-size: 12px;
  height: 32px;
}
.search-builder-tab .sb-adv-icon-btn {
  min-width: 28px;
  padding: 4px 8px;
}
.search-builder-tab .search-builder-listcard {
  border: none;
  background: transparent;
  box-shadow: none;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.search-builder-tab .search-builder-routes {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 4px 8px 8px;
}
.search-builder-tab .search-builder-routes-exp {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 4px 8px 8px;
}
.search-builder-tab .search-builder-pagination.interfacepagination {
  flex: 0 0 auto;
}
.search-builder-tab .search-builder-pagination.interfacepagination .mat-mdc-paginator {
  background-color: #f1f1f1 !important;
}
.search-builder-tab .search-builder-route-card {
  font-size: 12px;
}
.search-builder-tab .search-builder-route-card.active_card {
  border-left: 4px solid #07a36e;
  width: 100%;
}
.search-builder-tab .search-builder-route-card.failed_card {
  border-left: 4px solid #da606c;
  width: 100%;
}
.search-builder-tab .search-builder-route-card .search-builder-route-row {
  cursor: pointer;
}
.search-builder-tab .search-builder-route-card .pipelinenamediv:hover,
.search-builder-tab .search-builder-route-card .sb-pipeline-name-btn:hover {
  background-color: #3fa4fb;
  border-radius: 12px;
  color: white !important;
  padding: 3px !important;
  cursor: pointer;
}
.search-builder-tab .search-builder-route-card .sb-pipeline-name-btn,
.search-builder-tab .search-builder-route-card .sb-copy-text-btn {
  border: none;
  background: transparent;
  padding: 0;
  text-align: left;
  color: inherit;
  font: inherit;
  cursor: pointer;
}
.search-builder-tab .search-builder-route-card .sb-icon-copy-btn {
  border: none;
  background: transparent;
  padding: 0;
  line-height: 0;
  cursor: pointer;
}
.search-builder-tab .search-builder-route-card .redirectlink:hover,
.search-builder-tab .search-builder-route-card .sb-copy-text-btn:hover {
  background-color: #3fa4fb;
  border-radius: 12px;
  color: white;
  padding: 3px;
  cursor: pointer;
  height: 21px;
}
.search-builder-tab .search-builder-route-card .displayNamediv {
  color: #555;
  font-size: 11px;
}
.search-builder-tab .search-builder-route-card .sb-match-full {
  color: #07895c;
  font-weight: 700;
}
.search-builder-tab .search-builder-route-card .sb-match-partial {
  color: #c47a00;
  font-weight: 700;
}
.search-builder-tab .search-builder-route-card .copy_iconss {
  font-size: 14px;
  width: 14px;
  height: 14px;
  cursor: pointer;
  color: #17a2b8;
}

::ng-deep .search-builder-tab .sb-filter-input .autocomplete-container {
  height: auto;
  width: 100%;
}

::ng-deep .search-builder-tab .sb-filter-input form {
  width: 100%;
}

::ng-deep .search-builder-tab .ng-autocompleteaccount .autocomplete-container .input-container input {
  height: 32px;
  min-height: 32px;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/rule-engine-try-it-out/rule-engine-try-it-out.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EAEE,kBAAA;EACA,gBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAFF;;AAIA;EACE,aAAA;AADF;;AAIA;;EAEE,aAAA;EACA,gBAAA;EACA,qBAAA;AADF;;AAGA;EACE,YAAA;AAAF;;AAEA;EACE,eAAA;EACA,uBAAA;AACF;;AACA;EACE,WAAA;EACA,WAAA;AAEF;;AAEA;EACE,mBAAA;AACF;;AA+BA;EACE,uBCrEU;EDsEV,eAAA;EACA,gBAAA;EACA,0BC1ES;AD8CX;;AA8BA;EACE,0BC7ES;ADkDX;;AA8BA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,cAAA;EACA,YAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AA3BF;;AA8BA;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA3BF;;AA8BA;EACE,YAAA;EACA,WAAA;AA3BF;;AA8BA;EACE,WAAA;AA3BF;;AA8BA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,WAAA;EACE,eAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,oCAAA;EACA,UAAA;EACA,YAAA;AA3BJ;;AA6BC;EACC,4BAAA;AA1BF;;AA4BA;EACE,qBAAA;AAzBF;;AA6BA;EACE,kBAAA;EACA,oCChJU;EDiJV,kBAAA;EACA,0BCjJS;EDkJT,YAAA;AA1BF;;AA6BA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AA1BF;;AA4BA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AAzBF;;AA2BA;EACE,WAAA;EACA,UAAA;AAxBF;;AA0BA;EACE,oBAAA;AAvBF;;AAyBA;EACE,eAAA;AAtBF;;AAwBA;EAEE,eAAA;EACA,iBAAA;EACA,YAAA;EAEA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAvBF;;AAyBA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AAtBF;;AAwBA;EACE,WAAA;EACA,UAAA;AArBF;;AAuBA;EACE,6BAAA;EACA,mBAAA;AApBF;;AAsBA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AAnBF;;AAqBA;EACE,WAAA;EACA,UAAA;AAlBF;;AAqBA;EACE,eAAA;AAlBF;;AAoBA;EACI,WAAA;AAjBJ;;AAqBA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAlBF;;AAoBA;EACE,kBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,2BAAA;AAjBF;;AAoBA;EACE,2BAAA;AAjBF;;AAqBA;EACE,qBAAA;AAlBF;;AAoBA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;AAjBF;;AAmBA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AAhBF;;AAkBA;EACE,WAAA;EACA,UAAA;AAfF;;AAiBA;EACE,oBAAA;AAdF;;AAgBA;EACE,0BAAA;AAbF;;AAeA;EACE,6BAAA;EACA,qBAAA;AAZF;;AAgBA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;EACA,wBAAA;EAAyB,kCAAA;AAZ3B;;AAcA;EAEE,qBAAA;AAZF;AAaE;EACE,6BAAA;AAXJ;;AAeA;EACI,YAAA;AAZJ;;AAgBE;EACE,uBAAA;AAbJ;;AAgBE;EACE,uBAAA;AAbJ;;AAgBE;EACE,kCAAA;AAbJ;;AAgBA;EACE,gBAAA;AAbF;;AAgBA;EACE,qBAAA;EACA,UAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,yBAAA;AAbF;;AAgBA;EACE,YAAA;EACA,uBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAbF;;AAgBA;EACE,gBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAbF;;AAeA;EACE,gBAAA;EACA,aAAA;AAZF;;AAeA;EACE,cAAA;EACA,kBAAA;EACA,gDAAA;AAZF;;AAeA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAZF;AAcE;EACE,mDAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;AAZJ;AAeE;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;AAbJ;AAgBE;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AAdJ;AAiBE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAfJ;AAkBE;EACE,cAAA;AAhBJ;AAmBE;EACE,cAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;AAjBJ;AAoBE;EACE,cAAA;EACA,YAAA;EACA,WAAA;AAlBJ;AAqBE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;AAnBJ;AAsBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,iBAAA;AApBJ;AAsBI;EACE,SAAA;EACA,eAAA;AApBN;AAwBE;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAtBJ;AAyBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAvBJ;AA0BE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAxBJ;AA2BE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAzBJ;AA4BE;EACE,YAAA;EACA,eAAA;EACA,YAAA;AA1BJ;AA6BE;EACE,gBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;AA3BJ;AA8BE;EACE,eAAA;EACA,gBAAA;AA5BJ;AA+BE;EACE,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AA7BJ;AAgCE;EACE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AA9BJ;AAiCE;EACE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AA/BJ;AAkCE;EACE,cAAA;AAhCJ;AAkCI;EACE,oCAAA;AAhCN;AAoCE;EACE,eAAA;AAlCJ;AAoCI;EACE,8BAAA;EACA,WAAA;AAlCN;AAqCI;EACE,8BAAA;EACA,WAAA;AAnCN;AAsCI;EACE,eAAA;AApCN;AAuCI;;EAEE,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;AArCN;AAwCI;;EAEE,YAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AAtCN;AAyCI;EACE,YAAA;EACA,uBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;AAvCN;AA0CI;;EAEE,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AAxCN;AA2CI;EACE,WAAA;EACA,eAAA;AAzCN;AA4CI;EACE,cAAA;EACA,gBAAA;AA1CN;AA6CI;EACE,cAAA;EACA,gBAAA;AA3CN;AA8CI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AA5CN;;AAiDA;EACE,YAAA;EACA,WAAA;AA9CF;;AAiDA;EACE,WAAA;AA9CF;;AAiDA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;AA9CF","sourcesContent":["@import \"../../variables.scss\";\r\n\r\n.tryitouteditor {\r\n  //border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.tryitouteditor ngx-monaco-editor {\r\n  width: 100%;\r\n  height: 58vh;\r\n  position: relative;\r\n  right: 16px;\r\n}\r\n.example-tree-invisible {\r\n  display: none;\r\n}\r\n\r\n.example-tree ul,\r\n.example-tree li {\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n  list-style-type: none;\r\n}\r\n.textColor{\r\n  color: green;;\r\n}\r\n.mat-tree-node {\r\n  min-height: 1px;\r\n  align-items: flex-start;\r\n}\r\n.mat-icon-button{\r\n  height:1px;\r\n  width: 20px;\r\n}\r\n\r\n\r\n.mat-icon-rtl-mirror{\r\n  vertical-align: top;\r\n}\r\n// ::ng-deep.autocomplete-container {\r\n//   box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n//   position: relative;\r\n//   overflow: visible;\r\n//   height: 40px;\r\n//   border-radius: 5px;\r\n// }\r\n\r\n// ::ng-deep.autocomplete-container .input-container input{\r\n//   border-radius: 5px !important;\r\n//   padding-right: 12% !important;\r\n// }\r\n\r\n// .autocomplete-container {\r\n//   border-radius: 5px !important;\r\n// }\r\n// ::ng-deep.autocomplete-container .input-container .x i{\r\n//   font-weight: 600 !important;\r\n// }\r\n\r\n\r\n\r\n// ::ng-deep.pipeSearch .autocomplete-container {\r\n// height: 35px !important;\r\n// .input-container input{\r\n//   height: 35px !important;\r\n// }\r\n// }\r\n\r\n\r\n.accession_field{\r\n  height: $btnHeight;\r\n  margin-left: 3%;\r\n  padding-left: 2%;\r\n  font-size:$fontsize;\r\n}\r\n.accession_field::placeholder{\r\n  font-size: $fontsize;\r\n}\r\n\r\n.gqr-accession-col {\r\n  width: 190px;\r\n  max-width: 190px;\r\n  flex: 0 0 190px;\r\n}\r\n\r\n.gqr-entity-col {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n}\r\n\r\n.gqr-get-xml-btn-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  align-self: center;\r\n}\r\n\r\n.gqr-get-xml-btn {\r\n  height: 32px;\r\n  min-width: 36px;\r\n  padding: 0 10px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  line-height: 1;\r\n}\r\n\r\n::ng-deep .gqr-input-row .gqr-filter-input .autocomplete-container {\r\n  height: auto;\r\n  width: 100%;\r\n}\r\n\r\n::ng-deep .gqr-input-row .gqr-filter-input form {\r\n  width: 100%;\r\n}\r\n\r\n::ng-deep .gqr-input-row .ng-autocompleteaccount .autocomplete-container .input-container input {\r\n  height: 32px;\r\n  min-height: 32px;\r\n  font-size: 12px;\r\n}\r\n\r\n.field_droping{\r\n  width: 100%;\r\n    margin-left: 4%;\r\n    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n    border-radius: 5px;\r\n    padding-inline: 1%;\r\n    top: -3px;\r\n    background-color: rgb(255, 255, 255);\r\n    left: -5px;\r\n    height: 32px;\r\n}\r\n ::ng-deep .field_droping .mat-form-field-wrapper {\r\n  padding-bottom: 0 !important;\r\n}\r\n::ng-deep .field_droping .mat-form-field-flex {\r\n  padding: 0 !important;\r\n}\r\n\r\n\r\n.mod_header{\r\n  padding-inline: 1%;\r\n  background-color:$btn-color;\r\n  padding-block: 5px;\r\n  font-size: $fontsize;\r\n  color:white;\r\n}\r\n\r\n.Template_dropDown{\r\n  height: 32px;\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  position: relative;\r\n  top: 1%;\r\n  background-color: white;\r\n  margin-left: 1px;\r\n  margin-right: 2%;\r\n  margin-block: 1%;\r\n}\r\n::ng-deep.Template_dropDown  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.Template_dropDown .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.Template_dropDown .mat-form-field-label-wrapper{\r\n  top:-1px !important;\r\n}\r\n::ng-deep.Template_dropDown  .mat-select-trigger {\r\n  min-width: 10vw;\r\n}\r\n.mat_selection{\r\n  // width: 62%;\r\n  margin-left: 4%;\r\n  margin-bottom: 4%;\r\n  height: 35px;\r\n  // box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  padding-bottom: 1%;\r\n}\r\n::ng-deep.mat_selection  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.mat_selection .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.mat-selection_label .mat-form-field-label-wrapper{\r\n  position: absolute !important;\r\n  top: 1px !important;\r\n}\r\n::ng-deep.mat-selection_label  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.selection_label .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n\r\n::ng-deep.selection_label  .mat-select-trigger {\r\n  min-width: 10vw;\r\n}\r\n::ng-deep.path_class{\r\n    width: 100%;\r\n    // margin-top: 1%;\r\n}\r\n\r\n::ng-deep.pushmodal .modal-dialog {\r\n  max-width:50%!important;\r\n  max-height: 60%!important;\r\n  height: 60%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.pushmodal{\r\n  top: 4%!important;\r\n}\r\n\r\n.ellipsisfull{\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  /* width: 100% !important; */\r\n  max-width: 90%;\r\n}\r\n\r\n::ng-deep .field_droping .mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label{\r\n  margin-left: 8px !important;\r\n}\r\n\r\n::ng-deep .field_droping .mat-form-field-appearance-outline .mat-form-field-infix{\r\n  padding: 3px 7px !important;\r\n}\r\n\r\n\r\n::ng-deep.Version_dropDowns .mat-form-field-wrapper .mat-form-field-flex .mat-form-field-infix .mat-select .mat-select-trigger .mat-select-value{\r\n  width: 65% !important;\r\n}\r\n.Version_dropDowns{\r\n  height: 32px;\r\n  border-radius: 5px;\r\n  position: relative;\r\n  top: -7px;\r\n  background-color: white;\r\n  margin-block: 1%;\r\n  padding-left: 5px;\r\n  width: 60%;\r\n}\r\n::ng-deep.Version_dropDowns  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.Version_dropDowns .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.Version_dropDowns .mat-form-field-label-wrapper{\r\n  top:-1px !important;\r\n}\r\n::ng-deep.Version_dropDowns  .mat-select-trigger {\r\n  min-width: 13vw !important;\r\n}\r\n::ng-deep.Version_dropDowns  .mat-select-arrow {\r\n  position: relative !important;\r\n  right: 47% !important;\r\n}\r\n\r\n\r\n::ng-deep.myCustomModalViewfilehl7Viewer .modal-dialog {\r\n  max-width: 80% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  padding: 0 !important;\r\n  display: flex !important;justify-content: center !important;\r\n}\r\n::ng-deep.matoutlinestyles.versionfield\r\n{\r\n  width: 70% !important;\r\n  .mat-mdc-text-field-wrapper{\r\n    padding-block: 0px !important;\r\n  }\r\n}\r\n\r\n::ng-deep .rule-engine-tabs.mat-mdc-tab-group.mat-mdc-tab-group-stretch-tabs > .mat-mdc-tab-header .mat-mdc-tab {\r\n    flex-grow: 0;\r\n  }\r\n  \r\n \r\n  ::ng-deep .rule-engine-tabs .mat-mdc-tab {\r\n    background-color: white;\r\n  }\r\n  \r\n  ::ng-deep .rule-engine-tabs .mat-mdc-tab.mat-mdc-tab-active {\r\n    background-color: white;\r\n  }\r\n  \r\n  ::ng-deep .rule-engine-tabs .mat-mdc-tab-label-container {\r\n    background-color: white !important;\r\n  }\r\n\r\n.qualified-routes-list {\r\n  margin-top: 20px;\r\n}\r\n\r\n.qualified-routes-list ul {\r\n  list-style-type: none;\r\n  padding: 0;\r\n}\r\n\r\n.qualified-routes-list .route-item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 5px 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.qualified-routes-list .route-item:hover {\r\n  background-color: #e3eaec;\r\n}\r\n\r\n.qualified-routes-list .copy-icon-btn {\r\n  border: none;\r\n  background: transparent;\r\n  padding: 0;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  color: inherit;\r\n}\r\n\r\n.scrollable-output {\r\n  overflow-y: auto; \r\n  height: 52vh; \r\n  width: 90vh;\r\n  padding-right: 10px; \r\n  font-size: 12px;\r\n  margin-top: 25px;\r\n}\r\n.scrollable-routes {\r\n  overflow-y: auto; \r\n  padding: 10px; \r\n}\r\n\r\n.Ruleengineasterisk{\r\n  font-size: 7px;\r\n  position: absolute;\r\n  color: #f44455c4 !important;\r\n}\r\n\r\n.search-builder-tab {\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n\r\n  .search-builder-filter-card {\r\n    background-color: #d3d3d340;\r\n    border: none;\r\n    margin-bottom: 8px;\r\n    flex: 0 0 auto;\r\n    z-index: 5;\r\n  }\r\n\r\n  .modal-body {\r\n    flex: 1 1 auto;\r\n    min-height: 0;\r\n    overflow: hidden;\r\n    padding-top: 0 !important;\r\n  }\r\n\r\n  .search-builder-filter-row {\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n    align-items: center;\r\n    gap: 12px;\r\n    width: 100%;\r\n  }\r\n\r\n  .sb-filter-field {\r\n    display: flex;\r\n    flex: 1 1 0;\r\n    align-items: center;\r\n    gap: 6px;\r\n    min-width: 0;\r\n  }\r\n\r\n  .sb-filter-field-lab {\r\n    flex: 1.15 1 0;\r\n  }\r\n\r\n  .sb-filter-label {\r\n    flex: 0 0 auto;\r\n    white-space: nowrap;\r\n    margin: 0;\r\n    font-size: 12px;\r\n    padding-left: 4px;\r\n  }\r\n\r\n  .sb-filter-input {\r\n    flex: 1 1 auto;\r\n    min-width: 0;\r\n    width: 100%;\r\n  }\r\n\r\n  .sb-filter-actions {\r\n    flex: 0 0 auto;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    padding-right: 4px;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .sb-passive-checkbox {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    user-select: none;\r\n    margin-right: 4px;\r\n\r\n    input {\r\n      margin: 0;\r\n      cursor: pointer;\r\n    }\r\n  }\r\n\r\n  .search-builder-advanced-card {\r\n    border: 1px solid #d9d9d9;\r\n    border-radius: 6px;\r\n    padding: 8px 10px;\r\n    background: #fff;\r\n    max-height: 34vh;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n  }\r\n\r\n  .search-builder-advanced-title {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n  .search-builder-advanced-rule-row {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    gap: 6px;\r\n    margin-bottom: 6px;\r\n  }\r\n\r\n  .sb-adv-field {\r\n    width: 220px;\r\n    min-width: 160px;\r\n    font-size: 12px;\r\n    height: 32px;\r\n  }\r\n\r\n  .sb-adv-select-op {\r\n    width: 110px;\r\n    font-size: 12px;\r\n    height: 32px;\r\n  }\r\n\r\n  .sb-adv-value {\r\n    min-width: 160px;\r\n    flex: 1 1 140px;\r\n    font-size: 12px;\r\n    height: 32px;\r\n  }\r\n\r\n  .sb-adv-icon-btn {\r\n    min-width: 28px;\r\n    padding: 4px 8px;\r\n  }\r\n\r\n  .search-builder-listcard {\r\n    border: none;\r\n    background: transparent;\r\n    box-shadow: none;\r\n    height: 100%;\r\n    min-height: 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .search-builder-routes {\r\n    flex: 1 1 auto;\r\n    min-height: 0;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    padding: 4px 8px 8px;\r\n  }\r\n\r\n  .search-builder-routes-exp {\r\n    flex: 1 1 auto;\r\n    min-height: 0;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    padding: 4px 8px 8px;\r\n  }\r\n\r\n  .search-builder-pagination.interfacepagination {\r\n    flex: 0 0 auto;\r\n\r\n    .mat-mdc-paginator {\r\n      background-color: #f1f1f1 !important;\r\n    }\r\n  }\r\n\r\n  .search-builder-route-card {\r\n    font-size: 12px;\r\n\r\n    &.active_card {\r\n      border-left: 4px solid #07a36e;\r\n      width: 100%;\r\n    }\r\n\r\n    &.failed_card {\r\n      border-left: 4px solid #da606c;\r\n      width: 100%;\r\n    }\r\n\r\n    .search-builder-route-row {\r\n      cursor: pointer;\r\n    }\r\n\r\n    .pipelinenamediv:hover,\r\n    .sb-pipeline-name-btn:hover {\r\n      background-color: #3fa4fb;\r\n      border-radius: 12px;\r\n      color: white !important;\r\n      padding: 3px !important;\r\n      cursor: pointer;\r\n    }\r\n\r\n    .sb-pipeline-name-btn,\r\n    .sb-copy-text-btn {\r\n      border: none;\r\n      background: transparent;\r\n      padding: 0;\r\n      text-align: left;\r\n      color: inherit;\r\n      font: inherit;\r\n      cursor: pointer;\r\n    }\r\n\r\n    .sb-icon-copy-btn {\r\n      border: none;\r\n      background: transparent;\r\n      padding: 0;\r\n      line-height: 0;\r\n      cursor: pointer;\r\n    }\r\n\r\n    .redirectlink:hover,\r\n    .sb-copy-text-btn:hover {\r\n      background-color: #3fa4fb;\r\n      border-radius: 12px;\r\n      color: white;\r\n      padding: 3px;\r\n      cursor: pointer;\r\n      height: 21px;\r\n    }\r\n\r\n    .displayNamediv {\r\n      color: #555;\r\n      font-size: 11px;\r\n    }\r\n\r\n    .sb-match-full {\r\n      color: #07895c;\r\n      font-weight: 700;\r\n    }\r\n\r\n    .sb-match-partial {\r\n      color: #c47a00;\r\n      font-weight: 700;\r\n    }\r\n\r\n    .copy_iconss {\r\n      font-size: 14px;\r\n      width: 14px;\r\n      height: 14px;\r\n      cursor: pointer;\r\n      color: #17a2b8;\r\n    }\r\n  }\r\n}\r\n\r\n::ng-deep .search-builder-tab .sb-filter-input .autocomplete-container {\r\n  height: auto;\r\n  width: 100%;\r\n}\r\n\r\n::ng-deep .search-builder-tab .sb-filter-input form {\r\n  width: 100%;\r\n}\r\n\r\n::ng-deep .search-builder-tab .ng-autocompleteaccount .autocomplete-container .input-container input {\r\n  height: 32px;\r\n  min-height: 32px;\r\n  font-size: 12px;\r\n}","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
